module.exports = __webpack_public_path__ + "static/img/Onboarding.a37fa84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Onboarding.png
// module id = 7F1G
// module chunks = 0